<template>
  <page-template type="norightpanel" class="enquete">
    <template v-slot:toolbar>
        <tool-bar type="enquetes" title="Mes enquêtes" class="px-8"></tool-bar>
    </template>
    <template v-slot:main-panel-content>
      <div class="padding-x">
        <div class="d-flex rectangular-element-container">
          <rectangular-element
            v-for="poll in cachedPolls"
            :key="poll._id"
            :title="poll.title"
            :date="poll.updatedAt"
            :id="poll._id"
            :actions="items"
            linkresult="enquetes/resultat"
            @update="updatePolls()"
            :class="operation.activated ? 'on-going' : 'to-publish'"
          ></rectangular-element>
          <rectangular-element-new title="Nouvelle enquête" link="/enquetes/new"></rectangular-element-new>
        </div>
      </div>
    </template>
  </page-template>
</template>

<script>
  import pageTemplate from '@/templates/PageTemplate.vue'
  import toolBar from '@/components/ToolBar.vue'
  import rectangularElement from '@/components/RectangularElement.vue'
  import rectangularElementNew from '@/components/RectangularElementNew.vue'
  import axios from 'axios'
  import { apiURL } from '@/../config'
  export default {
    name: 'Enquetes',
    components: { pageTemplate, toolBar, rectangularElement, rectangularElementNew },
    data: () => {
      return {
        polls: []
      }
    },
    async created () {
      try {
        this.$store.dispatch('loading')
        // ALL POLLS
        const PollsRes = await axios.get(`${apiURL}/polls/all`)
        this.polls = PollsRes.data.model
      } catch (e) {
        alert('Une erreur est survenue, veuillez réessayer.')
        console.log(e)
      } finally {
        this.$store.dispatch('stop_loading')
      }
    },
    computed: {
      cachedPolls () {
        if (!this.polls.length) return []
        return this.polls.filter(p => {
          return p.done === this.status
        })
      },
      items () {
        return [
          { title: 'Editer', icon: 'mdi-square-edit-outline', callback: this.editCb },
          { title: 'Ouvrir', icon: 'mdi-eye-outline', callback: this.openCb },
          { title: 'Dupliquer', icon: 'mdi-checkbox-multiple-blank-outline', callback: this.duplicateCb },
          { title: 'Réponses', icon: 'mdi-chart-bar', callback: this.answersCb },
          { title: 'Désactiver', icon: 'mdi-close', callback: this.deactivateCb },
          { title: 'Supprimer', icon: 'mdi-trash-can-outline', callback: this.deleteCb }
        ]
      }
    },
    methods: {
      async updatePolls () {
        try {
          this.$store.dispatch('loading')
          // ALL POLLS
          const PollsRes = await axios.get(`${apiURL}/polls/all`)
          this.polls = PollsRes.data.model
        } catch (e) {
          alert('Une erreur est survenue, veuillez réessayer.')
          console.log(e)
        } finally {
          this.$store.dispatch('stop_loading')
        }
      },
      // EDIT POLL
      editCb (id) {
        this.$router.push(`/enquetes/edit/${id}`)
      },
      // OPEN POLL
      openCb (id) {
        this.$router.push(`/enquetes/open/${id}`)
      },
      // DUPLICATE POLL
      async duplicateCb (id) {
        try {
          this.$store.dispatch('loading')
          await axios.post(`${apiURL}/polls/duplicate/${id}`)
          await this.updatePolls()
        } catch (e) {
          alert('Une erreur est survenue, veuillez réessayer.')
          console.log(e)
        } finally {
          this.$store.dispatch('stop_loading')
        }
      },
      // GO TO ANSWERS
      answersCb (id) {
        this.$router.push(`/enquetes/resultat/${id}`)
      },
      // DEACTIVATE POLL
      async deactivateCb (id) {
        try {
          this.$store.dispatch('loading')
          await axios.put(`${apiURL}/polls/${id}/deactivate`)
          await this.updateOperations()
        } catch (e) {
          alert('Une erreur est survenue, veuillez réessayer.')
          console.log(e)
        } finally {
          this.$store.dispatch('stop_loading')
        }
      },
      // DELETE POLL
      async deleteCb (id) {
        try {
          this.$store.dispatch('loading')
          await axios.delete(`${apiURL}/polls/${id}`)
          await this.updateOperations()
        } catch (e) {
          alert('Une erreur est survenue, veuillez réessayer.')
          console.log(e)
        } finally {
          this.$store.dispatch('stop_loading')
        }
      }
    }
  }
</script>